import api from './api';

/**
 * @param
 * @returns {Promise<{
 *  task_id: string
 *  is_published: boolean
 *  task_id_name: string
 *  skill_id: 'speaking' | 'reading_writing' | 'listening'
 *  task_type_id: string
 *  description: string
 * }[]>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tasks-getAllTasks
 */
export default async function getTasks(level_id, anchor_only = false) {
    const { data } = await api.get(`levels/${level_id}/tasks${anchor_only ? '?anchor_only=true': ''}`);

    return data;
}